<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon>Closed Arrival/Departure
      </v-row>
    </th>
    <td class="sheet-cell pa-0" v-for="(price, index) in prices" :key="index">
      <v-progress-circular v-if="price.cau" size="12" width="2" indeterminate style="width: 50%"/>
      <v-btn v-else @click="updateArrival(price)" text tile height="30" class="sheet-switch-left" :ripple="false">
        <v-icon large style="line-height: 0;" v-text="price.closed_arrival ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="price.closed_arrival ? 'red' : 'grey darken-1'"/>
      </v-btn>
      <v-progress-circular v-if="price.cdu" size="12" width="2" indeterminate style="width: 50%"/>
      <v-btn v-else @click="updateDeparture(price)" text tile height="30" class="sheet-switch-right" :ripple="false">
        <v-icon large style="line-height: 0;" v-text="price.closed_departure ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="price.closed_departure ? 'red' : 'grey darken-1'"/>
      </v-btn>
    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {

      async updateArrival(data) {
        try {
          this.$set(data, 'cau', true);
          this.$set(data, 'closed_arrival', !data.closed_arrival);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'cau', false);
        }
      },

      async updateDeparture(data) {
        try {
          this.$set(data, 'cdu', true);
          this.$set(data, 'closed_departure', !data.closed_departure);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'cdu', false);
        }
      },

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>